import React from "react";
import PropTypes from "prop-types";
import { Avatar, Box, Link, Typography } from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { SIDEBAR } from "./sidebarVisual";
import { SidebarCard } from "./SidebarPrimitives";

/**
 * Compact read-only people row for V2 Company Details.
 */
export default function PersonCardV2({
  fullName,
  name,
  title,
  email,
  emails,
  phone,
  telephone,
  imageUrl,
}) {
  const displayName = fullName || name;
  const displayEmail = email || emails?.[0];
  const displayPhone = phone || telephone;

  if (!displayName && !displayEmail && !title) {
    return null;
  }

  return (
    <SidebarCard sx={{ px: 1.35, py: 1.15 }} testId="person-card-v2">
      <Box sx={{ display: "flex", gap: 1.15, alignItems: "flex-start", minWidth: 0 }}>
        <Avatar
          variant="rounded"
          src={imageUrl || undefined}
          sx={{
            width: 36,
            height: 36,
            borderRadius: "8px",
            bgcolor: SIDEBAR.surfaceMuted,
            color: "text.secondary",
            flexShrink: 0,
          }}
        >
          <PersonOutlineOutlinedIcon sx={{ fontSize: 20 }} />
        </Avatar>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            sx={{
              ...SIDEBAR.type.body,
              fontWeight: 700,
              letterSpacing: "-0.01em",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {displayName || "Contact"}
          </Typography>
          {title ? (
            <Typography sx={{ ...SIDEBAR.type.meta, mt: 0.2 }}>{title}</Typography>
          ) : null}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.25, mt: 0.65 }}>
            {displayEmail ? (
              <Link
                href={`mailto:${displayEmail}`}
                underline="hover"
                sx={{ fontSize: 12.5, color: "primary.main", fontWeight: 500 }}
              >
                {displayEmail}
              </Link>
            ) : null}
            {displayPhone ? (
              <Typography sx={{ ...SIDEBAR.type.meta }}>{displayPhone}</Typography>
            ) : null}
          </Box>
        </Box>
      </Box>
    </SidebarCard>
  );
}

PersonCardV2.propTypes = {
  fullName: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  email: PropTypes.string,
  emails: PropTypes.arrayOf(PropTypes.string),
  phone: PropTypes.string,
  telephone: PropTypes.string,
  imageUrl: PropTypes.string,
};
